export default __webpack_public_path__ + "static/media/Splash_Center.dd1eba3d.gif";